<mat-toolbar class="soft-toolbar"
  [class.tutorial-toolbar-active]="tutorialActive && tutorialStepIndex === -1">
  <button mat-icon-button type="button" (click)="toggleDrawer()"
    [class.tutorial-menu-target]="tutorialActive && tutorialStepIndex === -1"
    [attr.aria-label]="'MOBILE_TUTORIAL.INTRO.OPEN_MENU' | translate"
    style="background-color: transparent; color: aliceblue;">
    <mat-icon>{{!isDrawerOpen ? 'menu' : 'arrow_back'}}</mat-icon>
  </button>

  <span style="flex: 1; text-align: center;">{{buildingName}}</span>

  <button mat-icon-button (click)="reloadPage()" style="background-color: transparent; color: aliceblue;">
    <mat-icon>refresh</mat-icon>
  </button>
</mat-toolbar>

<mat-drawer-container class="example-container" [hasBackdrop]="true">
  <mat-drawer #drawer mode="over" (opened)="isDrawerOpen = true" (closed)="isDrawerOpen = false"
    [class.tutorial-drawer-active]="tutorialActive && tutorialStepIndex >= 0">
    <div class="drawer-layout">
      <div class="drawer-header">
        <h3 class="drawer-user-name">{{loggedUser?.name || 'Utente'}}</h3>
      </div>

      <div class="drawer-menu">
        @for (item of menuItems; track item.id) {
        <a #menuItemElement [routerLink]="tutorialActive ? undefined : item.routerLink || undefined"
          (click)="onMenuItemClick($event, item)" class="drawer-menu-item"
          (keydown.enter)="isGuideNavigationStep ? onMenuItemClick($event, item) : null"
          (keydown.space)="isGuideNavigationStep ? onMenuItemClick($event, item) : null"
          [attr.role]="isGuideNavigationStep ? 'button' : null"
          [class.mentorage-navigation-target]="isGuideNavigationStep && item.id === guide.navigationMenuItemId"
          [attr.tabindex]="isGuideNavigationStep ? (item.id === guide.navigationMenuItemId ? 0 : -1) : null"
          [class.tutorial-menu-item-target]="tutorialActive && currentTutorialItem?.id === item.id">
          @if (item.isSvgIcon) {
          <mat-icon class="drawer-menu-icon" [svgIcon]="item.icon"></mat-icon>
          } @else {
          <mat-icon class="drawer-menu-icon accent">{{item.icon}}</mat-icon>
          }
          <span class="drawer-menu-label">{{'SIDENAV.ITEMS.'+item.label | translate}}</span>
        </a>
        }
      </div>

      <div class="version-footer">
        <p>Versione: {{environment.short_env}}_{{environment.appVersion}}</p>
      </div>
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <ion-content>
      <app-monitoring-outlet></app-monitoring-outlet>
    </ion-content>
  </mat-drawer-content>

</mat-drawer-container>

@if (tutorialActive) {
@if (tutorialStepIndex === -1) {
<div class="tutorial-backdrop" aria-hidden="true"></div>
}

<section class="tutorial-card" appTutorialScrollLock [class.tutorial-card-menu]="tutorialStepIndex >= 0" role="dialog"
  aria-modal="true" aria-live="polite">
  <button type="button" class="tutorial-skip" (click)="skipTutorial()">
    {{'MOBILE_TUTORIAL.BUTTONS.SKIP' | translate}}
  </button>

  @if (tutorialStepIndex === -1) {
  <div class="tutorial-icon-wrap">
    <mat-icon>touch_app</mat-icon>
  </div>
  <h2>{{(isGuideNavigationStep ? (guide.navigationTranslationKey + '.TITLE') : 'MOBILE_TUTORIAL.INTRO.TITLE') | translate}}</h2>
  <p>{{(isGuideNavigationStep ? (guide.navigationTranslationKey + '.OPEN_MENU') : 'MOBILE_TUTORIAL.INTRO.DESCRIPTION') | translate}}</p>
  } @else if (isGuideNavigationStep) {
  <span class="tutorial-progress">{{'MOBILE_TUTORIAL.PROGRESS' | translate: { current: 1, total: guide.navigationTotal } }}</span>
  <h2>{{(guide.navigationTranslationKey + '.TITLE') | translate}}</h2>
  <p>{{(guide.navigationTranslationKey + '.MOBILE') | translate}}</p>
  } @else if (currentTutorialItem) {
  <span class="tutorial-progress">
    {{'MOBILE_TUTORIAL.PROGRESS' | translate: { current: tutorialStepIndex + 1, total: menuItems.length } }}
  </span>
  <h2>{{getTutorialTranslationKey('TITLE') | translate}}</h2>
  <p>{{getTutorialTranslationKey('DESCRIPTION') | translate}}</p>

  <div class="tutorial-actions">
    <button type="button" class="tutorial-secondary-button" (click)="previousTutorialStep()">
      {{'MOBILE_TUTORIAL.BUTTONS.BACK' | translate}}
    </button>
    <button type="button" class="tutorial-primary-button" (click)="nextTutorialStep()">
      {{(tutorialStepIndex === menuItems.length - 1
      ? 'MOBILE_TUTORIAL.BUTTONS.FINISH'
      : 'MOBILE_TUTORIAL.BUTTONS.NEXT') | translate}}
    </button>
  </div>
  }
</section>
}
@defer (when guide.activeModule === 'history' || guide.activeModule === 'settings') {
<app-guide-tour></app-guide-tour>
}
